import { Logger } from './logger';
const getCookie = name => {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
};
const createRequest = (url, reqConfig) => {
  var headers = Object.assign({
    "Content-Type": "application/json"
  }, reqConfig.header || {});
  const token = getCookie("authToken");
  // const userId = getCookie("businessUserId");
  // const userName = getCookie("businessUserName");

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  // if (userId) {
  //   headers["X-USR-ID"] = userId;
  // }
  // if (userName) {
  //   headers["X-USR-NAME"] = userName;
  // }

  if (reqConfig.query) {
    url = serializeQueryParams(url, reqConfig.query);
  }
  var requestOption = {
    method: reqConfig.method,
    headers: headers,
    credentials: reqConfig.isCORS ? "include" : "same-origin"
  };
  if (reqConfig.data) {
    requestOption["body"] = typeof reqConfig.data !== "string" ? JSON.stringify(reqConfig.data) : reqConfig.data;
  } else if (reqConfig.body) {
    requestOption["body"] = reqConfig.body;
  }
  if (reqConfig.signal) {
    // eslint-disable-next-line no-self-assign
    requestOption['signal'] = requestOption.signal;
  }
  return new Request(url, requestOption);
};
const serializeQueryParams = (url, params = {}) => {
  var queryString = url.lastIndexOf('?') !== -1 ? `&` : `?`;
  Object.keys(params).forEach(key => {
    queryString += `${key}=${encodeURIComponent(params[key])}&`;
  });
  return `${url}${queryString}`;
};
const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
};
const sendRequest = (url, options, status) => {
  let request = createRequest(url, options);
  let promise = fetch(request).then(response => {
    let emptyCodes = [204, 205];
    if (status) {
      emptyCodes = [204, 205, 400];
    }
    const contentType = response.headers.get('Content-Type');
    const isJSON = emptyCodes.indexOf(response.status) === -1 && contentType && contentType.indexOf('json') !== -1;
    if (isJSON) {
      return response.json().then(json => {
        return response.ok ? json : Promise.reject(json);
      });
    } else {
      return Promise.resolve(response);
    }
  });
  return promise;
};
const service = {
  get: (url, options = {}) => {
    options.method = "GET";
    return sendRequest(url, options);
  },
  getBulk: (url, options = {}) => {
    return Promise.all(url.map(endpoint => sendRequest(endpoint, options, true))).then(response => response);
  },
  postBulk: (url, options = {}) => {
    options.method = "POST";
    return Promise.all(url.map(endpoint => sendRequest(endpoint, options))).then(response => response);
  },
  post: (url, options = {}) => {
    options.method = options.method || "POST";
    return sendRequest(url, options);
  },
  update: function (url, options = {}) {
    options.method = "PUT";
    return this.post(url, options);
  },
  patch: function (url, options = {}) {
    options.method = "PATCH";
    return sendRequest(url, options);
  },
  delete: (url, options = {}) => {
    options.method = "DELETE";
    return sendRequest(url, options);
  },
  fetch: (url, options = {}) => {
    options = Object.assign({
      method: 'GET'
    }, options);
    let request = createRequest(url, options);
    return fetch(request).then(checkStatus);
  },
  upload: (url, options = {}) => {
    let request = createRequest(url, options);
    return fetch(request).then(checkStatus).catch(err => {
      return Promise.reject(err);
    });
  }
};
export default service;